import { z } from 'zod';
const hexColorSchema = z
    .string()
    .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Please enter a valid hex color (e.g., #FF0000)');
// Zod validation schema
export const labelCreateSchema = z.object({
    value: z
        .string()
        .min(1, 'Label text is required')
        .max(50, 'Label text must be 50 characters or less')
        .trim(),
    foregroundColor: hexColorSchema,
    backgroundColor: hexColorSchema,
});
export const labelSchema = z.object({
    id: z.string(),
    value: z.string(),
    foregroundColor: z.string(),
    backgroundColor: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
